import { render, staticRenderFns } from "./AskForArchiveData.vue?vue&type=template&id=b614f03a"
import script from "./AskForArchiveData.vue?vue&type=script&lang=js"
export * from "./AskForArchiveData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports